module.exports = __webpack_public_path__ + "4ff2b2f17801cd6ba999a5ce0143ed96.png";